import Ajax from '@utils/ajax';

export function addNewItem(label, listId) {
	return Ajax.post(`/settings/list.php?id=${ listId }`, Ajax.prepareData({
		action: 'Add',
		ajax: 1,
		label,
	}, Ajax.prepareDataTypes.FORM_DATA));
}
